<template>
    <div class="pdf_container">
        <div v-if="downloading || (!blobURI && !downloading)" class="uk-flex uk-flex-column uk-flex-middle">
            <div class="uk-width-1-2 uk-width-1-3@m uk-text-center uk-margin-large-top">
                <span v-if="downloading" uk-spinner="ratio: 2.5"></span>
                <p v-if="!blobURI && !downloading" class="uk-text-warning"><span uk-icon="icon: info"></span> {{ $t('doc_view.null') }}</p>
            </div>
        </div>
        <iframe v-if="blobURI && !downloading" :src="absoluteUrl(blobURI)" allowfullscreen></iframe>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";

    export default {
        name: "DocView",
        props: {
            url: { required: true, type: String },
        },
        created() {
            this.$http.get(this.docURI, {
                responseType: "blob",
                timeout: 40 * 1000
            }).then(r => {
                if (r.headers["content-length"] !== "0") {
                    this.blobURI = URL.createObjectURL(r.data);
                }
            }).catch(err => {
                this.$router.push({
                    name: "errorView",
                    params: { status: err.response.status, message: this.$t('error_unexpected') }
                });
            }).then(() => {
                this.downloading = false;
            });
        },
        data() {
            return {
                downloading: true,
                blobURI: null
            };
        },
        methods: {
            absoluteUrl(blobURI) {
                return encodeURI("/static/pdf/web/viewer.html?file=" + blobURI)
            },
        },
        computed: {
            ...mapGetters(["user"]),
            docURI() {
                const query = {
                    ...this.$route.query,
                    ...(this.user.token && { tkn: this.user.token })
                };
                const queryString = Object.entries(query).map(([key, val]) => key + "=" + val).join("&"); // a=b&c=d&e=f...
                return this.url + (queryString ? "?" + queryString : "");
            }
        }
    };
</script>

<style scoped>
    .pdf_container {
        position: absolute;
        top: 95px;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .pdf_container iframe {
        width: 100%;
        height: 100%;
    }
</style>